import { useEffect, useState } from "react";
import axios from "axios";

const Step1 = ({ formValues, handleChange, handleNextStep, errors }) => {
    const [years, setYears] = useState([]);
    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [styles, setStyles] = useState([]);

    const [customInputs, setCustomInputs] = useState({
        year: false,
        make: false,
        model: false,
        style: false,
    });

    const isVINLocked = formValues.vin && formValues.vin.length === 17;

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const yearList = Array.from({ length: currentYear - 1979 }, (_, i) => (1980 + i).toString());
        setYears(yearList.reverse());
    }, []);

    useEffect(() => {
        if (formValues.year && !customInputs.year) {
            axios
                .get(`https://vpic.nhtsa.dot.gov/api/vehicles/GetMakesForVehicleType/car?format=json`)
                .then((res) => {
                    const options = res.data.Results.map((item) => item.MakeName).sort();
                    setMakes(options);
                });
        }
    }, [formValues.year, customInputs.year]);

    useEffect(() => {
        if (formValues.make && formValues.year && !customInputs.make) {
            axios
                .get(
                    `https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMakeYear/make/${formValues.make}/modelyear/${formValues.year}?format=json`
                )
                .then((res) => {
                    const options = res.data.Results.map((item) => item.Model_Name).sort();
                    setModels(options);
                });
        }
    }, [formValues.make, formValues.year, customInputs.make]);

    useEffect(() => {
        if (formValues.model && !customInputs.model) {
            setStyles(["2 Door", "4 Door", "Convertible", "Hatchback", "SUV", "Truck"]);
        }
    }, [formValues.model, customInputs.model]);

    const handleSelectChange = (e) => {
        const { name, value } = e.target;

        if (value === "other") {
            setCustomInputs((prev) => ({ ...prev, [name]: true }));
            handleChange({ target: { name, value: "" } });
        } else {
            setCustomInputs((prev) => ({ ...prev, [name]: false }));
            handleChange(e);
        }
    };

    const renderField = (name, options, placeholder, disabled = false) => {
        if (customInputs[name]) {
            return (
                <input
                    type="text"
                    name={name}
                    value={formValues[name]}
                    onChange={handleChange}
                    placeholder={`Enter ${placeholder}`}
                    disabled={isVINLocked || disabled}
                    className={`p-2 rounded-lg bg-white border-2 ${
                        errors[name] ? "border-red-500" : "border-primary"
                    }`}
                />
            );
        }

        return (
            <select
                name={name}
                value={formValues[name]}
                onChange={handleSelectChange}
                disabled={isVINLocked || disabled}
                className={`p-2 rounded-lg bg-white border-2 ${
                    errors[name] ? "border-red-500" : "border-primary"
                }`}
            >
                <option value="">{placeholder}</option>
                {options.map((opt) => (
                    <option key={opt} value={opt}>
                        {opt}
                    </option>
                ))}
                <option value="other">Other (Not Listed)</option>
            </select>
        );
    };

    return (
        <div className="flex flex-col gap-4 w-full h-full">
            <div className="flex-col flex h-full gap-4">
                {renderField("year", years, "Year")}
                {errors.year && <div className="text-red-500">{errors.year}</div>}

                {renderField("make", makes, "Make", !formValues.year)}
                {errors.make && <div className="text-red-500">{errors.make}</div>}

                {renderField("model", models, "Model", !formValues.make)}
                {errors.model && <div className="text-red-500">{errors.model}</div>}

                {renderField("style", styles, "Style", !formValues.model)}
                {errors.style && <div className="text-red-500">{errors.style}</div>}

                <input
                    type="text"
                    name="vin"
                    value={formValues.vin}
                    onChange={handleChange}
                    placeholder="VIN #"
                    className={`p-2 rounded-lg bg-white border-2 ${
                        errors.vin ? "border-red-500" : "border-primary"
                    }`}
                />
                {errors.vin && <div className="text-red-500">{errors.vin}</div>}
            </div>
        </div>
    );
};

export default Step1;
